import React from "react";
import { Heading } from "@usap/uicomponents";
// 16px
export default function Heading5({ title = "", ...props }) {
  return (
    <Heading
      responsive={false}
      level={5}
      margin="0px"
      color="dark-2"
      {...props}
      dangerouslySetInnerHTML={{
        __html: title
      }}
    />
  );
}
